<template>
  <div>
    <div class="top-part">
      <div class="switch">
        <div :class="{'slider':true, 'active':quickRes.enable, 'disabled':quickRes.loading || !editEnabled}"
          @click="confirmQuickRes"></div>
        <span class="label" v-show="quickRes.enable">Quick Res ENABLED</span>
        <span class="label" v-show="!quickRes.enable">Quick Res DISABLED</span>
      </div>

      <div :class="['driver-id', {'filled':!nextDriverId}]">
        <label>VEHICLE #</label>
        <label class="value">{{accountType.type.toUpperCase()}}-{{driverId}}</label>
        <input type="text" v-model="driverId" :disabled="driverIdLoading"
          :class="{'no-access':driverNumEnabled, 'has-error':!!driverIdError}" readonly />
        <button @click="saveDriverId" :class="{disabled:driverIdLoading || !editEnabled}" v-if="nextDriverId && driverNumEnabled" :disabled="!editEnabled">
          <span v-if="!driverIdLoading">SAVE</span>
          <i class="fas fa-spinner fa-spin" v-else></i>
        </button>
        <!-- <span class="next-id" v-if="nextDriverId">NEXT: {{nextDriverId}}</span> -->
        <span class="error-msg" v-if="driverIdError">{{driverIdError}}</span>
        <transition name="slide-down">
          <span class="saved" v-show="driverIdSuccess">Driver ID saved.</span>
        </transition>
      </div>
    </div>

    <div class="other-data">
      <div class="field-row">
        <div class="data-field col col50 no-label">
          <div class="checkbox">
            <input type="checkbox" id="backgroundSubmitted" v-model="backgroundSubmitted" :disabled="!editEnabled" />
            <label for="backgroundSubmitted">{{ $t('provider.backgroundSubmitted') }}</label>
          </div>
          <div class="checkbox">
            <input type="checkbox" id="backgroundPassed" v-model="backgroundPassed" :disabled="!editEnabled" />
            <label for="backgroundPassed">{{ $t('provider.backgroundPassed') }}</label>
          </div>
        </div>
        <div class="data-field col col50">
          <div class="label">{{ $t('provider.maxRsvp') }}:</div>
          <label class="radio">
            <input type="radio" class="input" name="maxDailyRsvp" value="0"
              v-model="maxDailyRsvpIsCustom" :disabled="!editEnabled" />
            {{ $t('provider.default') }}
          </label>
          <label class="radio">
            <input type="radio" class="input" name="maxDailyRsvp" value="1"
              v-model="maxDailyRsvpIsCustom" />
            {{ $t('provider.custom') }}
              <input type="number" class="input" v-model="maxDailyRsvp"
                :disabled="maxDailyRsvpIsCustom === '0' || !editEnabled"/>
          </label>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.basicInfo}">
      <div class="heading" @click="contentShow.basicInfo = !contentShow.basicInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.basicInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.basicInfo"></i>
        <span>{{ $t('provider.basicInfo.label') }}</span>
      </div>

      <div class="content">
        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="basicInfo.img" target="_blank"
                v-if="basicInfo.img !== ''" >
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(basicInfo.img)"></i>
                <img :src="basicInfo.img" v-else />
              </a>
              <i class="fa fa-image" v-if="basicInfo.img === ''"></i>
              <a @click="triggerCropUpload('basicInfo')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(basicInfo.img).class]">
                {{ imgUploadButton(basicInfo.img).label }}
              </a>
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.basicInfo.firstName') }}*</div>
                <input type="text" v-model="basicInfo.firstName" :disabled="!editEnabled"
                  @keyup="fieldValidate('basicInfo', 'firstName')"
                  :class="{'input':true, 'has-error':!!validation.basicInfo.firstName }"/>
                <span class="error-msg">{{ validation.basicInfo.firstName }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.basicInfo.lastName') }}*</div>
                <input type="text" v-model="basicInfo.lastName" :disabled="!editEnabled"
                  @keyup="fieldValidate('basicInfo', 'lastName')"
                  :class="{'input':true, 'has-error':!!validation.basicInfo.lastName }" />
                <span class="error-msg">{{ validation.basicInfo.lastName }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.basicInfo.deviceOS') }}*</div>
                <select :class="{'has-error':!!validation.basicInfo.deviceOS }"
                  @change="fieldValidate('basicInfo', 'deviceOS')"
                  v-model="basicInfo.deviceOS" :disabled="!editEnabled">
                  <option value="Android">Android</option>
                  <option value="iOS">iOS</option>
                  <option value="Windows">Windows</option>
                  <option value="Other">Other</option>
                </select>
                <span class="error-msg">{{ validation.basicInfo.deviceOS }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.basicInfo.deviceModel') }}</div>
                <input type="text" v-model="basicInfo.deviceModel" :disabled="!editEnabled"
                  @keyup="fieldValidate('basicInfo', 'deviceModel')"
                  :class="{'input':true, }" /> <!-- 'has-error':!!validation.basicInfo.deviceModel  -->
                <!-- <span class="error-msg">{{ validation.basicInfo.deviceModel }}</span> -->
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.basicInfo.birthday') }}*</div>
                <datepicker :selected="fieldValidate('basicInfo', 'birthday')" v-if="editEnabled"
                  :class="{'datepicker':true, 'has-error':!!validation.basicInfo.birthday}" v-model="basicInfo.birthday" :format="calendarFormat"></datepicker>
                <input type="text" :disabled="!editEnabled" v-else disabled="disabled"
                  class="input" :value="basicInfo.birthday" />
                <span class="error-msg">{{ validation.basicInfo.birthday }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.basicInfo.language') }}*</div>
                <select :class="{'has-error':!!validation.basicInfo.language }"
                  @change="fieldValidate('basicInfo', 'language')"
                  v-model="basicInfo.language" :disabled="!editEnabled">
                  <option value="Chinese">Chinese</option>
                  <option value="Deutsch">Deutsch</option>
                  <option value="English">English</option>
                  <option value="French">French</option>
                  <option value="Italian">Italian</option>
                  <option value="Japanese">Japanese</option>
                  <option value="Korean">Korean</option>
                  <option value="Spanish">Spanish</option>
                </select>
                <span class="error-msg">{{ validation.basicInfo.language }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.basicInfo.email') }}*</div>
                <input type="text" v-model="basicInfo.email" :disabled="!editEnabled"
                  @keyup="fieldValidate('basicInfo', 'email')"
                  :class="{'input':true, 'has-error':!!validation.basicInfo.email }" />
                <span class="error-msg">{{ validation.basicInfo.email }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.basicInfo.mobile') }}*</div>
                <div :class="{'input-group':true}">
                  <div class="country-select input-group-label" @click="selectCountry">
                    <span class="country-code">(+{{callingCode}}) </span>
                    <i class="fa fa-caret-down"></i>
                  </div>
                  <input type="text" v-model="basicInfo.phoneNumber" :disabled="!editEnabled"
                    @keyup="fieldValidate('basicInfo', 'mobile')"
                    :class="{'input':true, 'has-error':!!validation.basicInfo.phoneNumber }" />
                </div>
                <span class="error-msg">{{ validation.basicInfo.phoneNumber }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100 password-div">
                <a class="button cta small" @click="showResetPassword" > <!-- v-if="editEnabled" -->
                  {{ $t('provider.basicInfo.resetPassword') }}
                </a>
                <div class="reset-password-wrap">
                  <reset-password :show="showResetPassword"
                    ref="resetPassword"></reset-password>
                </div>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100 mark-test-account">
                <label>
                  <input type="checkbox" v-model="isTestAcct" />
                  Mark as test account
                </label>
              </div>
            </div>
          </div>
          </div>
        </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.vehicleInfo}">
      <div class="heading" @click="contentShow.vehicleInfo = !contentShow.vehicleInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.vehicleInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.vehicleInfo"></i>
        <span>{{ $t('provider.vehicleInfo.label') }}</span>
      </div>

      <div class="content">
        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="vehicleInfo.img" target="_blank"
                v-if="vehicleInfo.img !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(vehicleInfo.img)"></i>
                <img :src="vehicleInfo.img" v-else/>
              </a>
              <i class="fa fa-image" v-if="vehicleInfo.img === ''"></i>
              <a @click="triggerCropUpload('vehicleInfo')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(vehicleInfo.img).class]">
                {{ imgUploadButton(vehicleInfo.img).label }}
              </a>
            </div>
          </div>

          <div class="fields">
            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.vehicleInfo.manufacturer') }}*</div>
                <input type="text" v-model="vehicleInfo.manufacturer" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'manufacturer')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.manufacturer }"/>
                <span class="error-msg">{{ validation.vehicleInfo.manufacturer }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.vehicleInfo.model') }}*</div>
                <input type="text" v-model="vehicleInfo.model" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'model')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.model }"/>
                <span class="error-msg">{{ validation.vehicleInfo.model }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.vehicleInfo.year') }}*</div>
                <input type="text" v-model="vehicleInfo.year" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'year')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.year }"/>
                <span class="error-msg">{{ validation.vehicleInfo.year }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.vehicleInfo.type') }}*</div>
                <select v-model="vehicleInfo.type" :disabled="!editEnabled"
                  @change="fieldValidate('vehicleInfo', 'type')"
                  :class="{'has-error':!!validation.vehicleInfo.type }">
                  <!-- <option value="Convertible">Convertible</option> -->
                  <!-- <option value="Coupe">Coupe</option> -->
                  <!-- <option value="Hatchback">Hatchback</option> -->
                  <!-- <option value="Pickup Truck">Pickup Truck</option> -->
                  <option value="Sedan">Sedan</option>
                  <option value="Mini SUV">Mini SUV</option>
                  <option value="Minivan">Minivan</option>
                  <option value="Black Car">Black Car</option>
                  <option value="Black SUV">Black SUV</option>
                  <!-- <option value="Van">Van</option> -->
                  <option value="Limousine">Limousine</option>
                  <!-- <option value="SUV">SUV</option> -->
                  <option value="Tesla">Tesla</option>
                  <option value="Private Van">Private Van</option>
                  <option value="Mini Bus">Mini Bus</option>
                  <option value="34 Pax Bus">34 Pax Bus</option>
                  <option value="56 Pax Bus">56 Pax Bus</option>
                </select>
                <span class="error-msg">{{ validation.vehicleInfo.type }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.vehicleInfo.licensePlate') }}*</div>
                <input type="text" v-model="vehicleInfo.licensePlate" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'licensePlate')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.licensePlate }"/>
                <span class="error-msg">{{ validation.vehicleInfo.licensePlate }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.vehicleInfo.identificationNumber') }}*</div>
                <input type="text" v-model="vehicleInfo.identificationNumber" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'identificationNumber')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.identificationNumber }"/>
                <span class="error-msg">{{ validation.vehicleInfo.identificationNumber }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.vehicleInfo.door') }}*</div>
                <input type="text" v-model="vehicleInfo.door" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'door')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.door }"/>
                <span class="error-msg">{{ validation.vehicleInfo.door }}</span>
              </div>
              <div :class="['data-field col', isDoorToDoorEnabled ? 'col33':'col50']">
                <div class="label">{{ $t('provider.vehicleInfo.capacity') }}*</div>
                <input type="text" v-model="vehicleInfo.capacity" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'capacity')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.capacity }"/>
                <span class="error-msg">{{ validation.vehicleInfo.capacity }}</span>
              </div>
              <div class="data-field col col34" v-show="isDoorToDoorEnabled">
                <div class="label">{{ $t('provider.vehicleInfo.boxCapacity') }}*</div>
                <input type="text" v-model="vehicleInfo.boxCapacity" :disabled="!editEnabled"
                  @keyup="fieldValidate('vehicleInfo', 'boxCapacity')"
                  :class="{'input':true, 'has-error':!!validation.vehicleInfo.boxCapacity }"/>
                <span class="error-msg">{{ validation.vehicleInfo.boxCapacity }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col100 pwd">
                <div class="checkbox">
                  <input type="checkbox" id="wheelchair" v-model="vehicleInfo.wheelchair" :disabled="!editEnabled" />
                  <label for="wheelchair">{{ $t('provider.vehicleInfo.wheelchair') }}</label>
                </div>
                <div class="checkbox">
                  <input type="checkbox" id="serviceDog" v-model="vehicleInfo.serviceDog" :disabled="!editEnabled" />
                  <label for="serviceDog">{{ $t('provider.vehicleInfo.serviceDog') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.vehicleRegistrationImg" target="_blank"
                v-if="documentation.vehicleRegistrationImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.vehicleRegistrationImg)"></i>
                <img :src="documentation.vehicleRegistrationImg" v-else />
              </a>
              <i class="fa fa-image" v-if="documentation.vehicleRegistrationImg === ''"></i>
              <a @click="triggerUploadInput('vehicleRegistrationImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.vehicleRegistrationImg).class, {'disabled':fileLoading.vehicleRegistrationImg}]">
                <span v-show="!fileLoading.vehicleRegistrationImg">{{ imgUploadButton(documentation.vehicleRegistrationImg).label }}</span>
                <span v-show="fileLoading.vehicleRegistrationImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="vehicleRegistrationImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">Vehicle Registration</div>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.drivingRecordExp') }}</div>
                <datepicker class="datepicker" v-model="documentation.vehicleRegistrationExp"
                  :format="calendarFormat" v-if="editEnabled"></datepicker>
                <input type="text" v-else disabled="disabled" class="input" :value="documentation.vehicleRegistrationExp" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.accountType}">
      <div class="heading" @click="contentShow.accountType = !contentShow.accountType">
        <i class="fa fa-minus-circle" v-show="contentShow.accountType"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.accountType"></i>
        <span>{{ $t('provider.accountType.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col100">
            <!-- <div class="label">{{ $t('provider.accountType.type') }}</div> -->
            <label class="radio">
              <input type="radio" class="input" name="override"
                :checked="accountType.type === 'tnc'" @click="updateAccountType('tnc')"
                :disabled="!editEnabled" />
              TNC
            </label>
            <label class="radio">
              <input type="radio" class="input" name="override"
                :checked="accountType.type === 'tcp'" @click="updateAccountType('tcp')"
                :disabled="!editEnabled" />
              TCP
            </label>
            <label class="radio" v-if="!useOldQuatation">
              <input type="radio" class="input" name="override"
                :checked="accountType.type === 'psc'" @click="updateAccountType('psc')"
                :disabled="!editEnabled" />
              PSC
            </label>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.businessInfo}"
      v-show="(accountType.type === 'tcp' || ((accountType.type === 'tnc' || accountType.type === 'psc') && enableTCPDocToTNC))">
      <div class="heading" @click="contentShow.businessInfo = !contentShow.businessInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.businessInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.businessInfo"></i>
        <span>{{ $t('provider.businessInfo.label') }}</span>
      </div>

      <div class="content">
        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail" v-show="businessInfo.type === 'Sole Proprietorship'">
              <a :href="businessInfo.ssnImg" target="_blank"
                v-if="businessInfo.ssnImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(businessInfo.ssnImg)"></i>
                <img :src="businessInfo.ssnImg" v-else />
              </a>
              <i class="fa fa-image" v-if="businessInfo.ssnImg === ''"></i>
              <div class="ssn-ein-label">SSN Image</div>
              <a @click="triggerUploadInput('ssnImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(businessInfo.ssnImg).class, {'disabled':fileLoading.ssnImg}]">
                <span v-show="!fileLoading.ssnImg">{{ imgUploadButton(businessInfo.ssnImg).label }}</span>
                <span v-show="fileLoading.ssnImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="ssnImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
            <div class="thumbnail">
              <a :href="businessInfo.einImg" target="_blank"
                v-if="businessInfo.einImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(businessInfo.einImg)"></i>
                <img :src="businessInfo.einImg" v-else />
              </a>
              <i class="fa fa-image" v-if="businessInfo.einImg === ''"></i>
              <div class="ssn-ein-label">EIN Image</div>
              <a @click="triggerUploadInput('einImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(businessInfo.einImg).class, {'disabled':fileLoading.einImg}]">
                <span v-show="!fileLoading.einImg">{{ imgUploadButton(businessInfo.einImg).label }}</span>
                <span v-show="fileLoading.einImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="einImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>

          <div class="fields">
            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.businessInfo.name') }}*</div>
                <input type="text" v-model="businessInfo.name" :disabled="!editEnabled"
                  @keyup="fieldValidate('businessInfo', 'name')"
                  :class="{'input':true, 'has-error':!!validation.businessInfo.name }"/>
                <span class="error-msg">{{ validation.businessInfo.name }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.businessInfo.type') }}*</div>
                <select :class="{'has-error':!!validation.businessInfo.type }"
                  @change="fieldValidate('businessInfo', 'type')"
                  v-model="businessInfo.type" :disabled="!editEnabled">
                  <option value="Sole Proprietorship">Sole Proprietorship</option>
                  <option value="C Corp">C Corp</option>
                  <option value="S Corp">S Corp</option>
                  <option value="LLC">LLC</option>
                </select>
                <span class="error-msg">{{ validation.businessInfo.type }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col100" v-if="businessInfo.type === 'Sole Proprietorship'">
                <div class="label">Social Security Number (SSN)*</div>
                <input type="text" v-model="businessInfo.ssn" :disabled="!editEnabled" @focus="focusChangeCheck('ssn')"
                  @keyup="fieldValidate('businessInfo', 'ssn')" v-on:keypress="isNumber" @blur="changeCheck('ssn')"
                  :class="{'input':true, 'has-error':!!validation.businessInfo.ssn }"/>
                <span class="error-msg">{{ validation.businessInfo.ssn }}</span>
              </div>
              <div class="data-field col col100">
                <div class="label">Employer ID Number (EIN)*</div>
                <input type="text" v-model="businessInfo.ein" :disabled="!editEnabled"
                  @keyup="fieldValidate('businessInfo', 'ein')"  @focus="focusChangeCheck('ein')" @blur="changeCheck('ein')"
                  :class="{'input':true, 'has-error':!!validation.businessInfo.ein }"/>
                <span class="error-msg">{{ validation.businessInfo.ein }}</span>
              </div>
            </div>
            
            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.businessInfo.address1') }}*</div>
                <input type="text" v-model="businessInfo.address1" :disabled="!editEnabled"
                  @keyup="fieldValidate('businessInfo', 'address1')"
                  :class="{'input':true, 'has-error':!!validation.businessInfo.address1 }"/>
                <span class="error-msg">{{ validation.businessInfo.address1 }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.businessInfo.address2') }}</div>
                <input type="text" v-model="businessInfo.address2" class="input" :disabled="!editEnabled"/>
                <span class="error-msg">{{ validation.businessInfo.address2 }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.businessInfo.city') }}*</div>
                <input type="text" v-model="businessInfo.city" :disabled="!editEnabled"
                  @keyup="fieldValidate('businessInfo', 'city')"
                  :class="{'input':true, 'has-error':!!validation.businessInfo.city }"/>
                <span class="error-msg">{{ validation.businessInfo.city }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.businessInfo.country') }}*</div>
                <select v-model="businessInfo.country" :disabled="!editEnabled"
                  @change="fieldValidate('businessInfo', 'country')"
                  :class="{'has-error':!!validation.businessInfo.country }">
                  <option v-for="country in countries.all">{{country.name}}</option>
                </select>
                <span class="error-msg">{{ validation.businessInfo.country }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col50" v-show="businessInfo.country === 'United States'">
                <div class="label">{{ $t('provider.businessInfo.state') }}*</div>
                <select v-model="businessInfo.state" :disabled="!editEnabled"
                  @change="fieldValidate('businessInfo', 'state')"
                  :class="{'has-error':!!validation.businessInfo.state }">
                  <option v-for="state in states" :value="state.value">{{state.label}}</option>
                </select>
                <span class="error-msg">{{ validation.businessInfo.state }}</span>
              </div>
              <div class="data-field col col50">
                <div class="label">{{ $t('provider.businessInfo.zip') }}*</div>
                <input type="text" v-model="businessInfo.zip" :disabled="!editEnabled"
                  @keyup="fieldValidate('businessInfo', 'zip')"
                  :class="{'input':true, 'has-error':!!validation.businessInfo.zip }"/>
                <span class="error-msg">{{ validation.businessInfo.zip }}</span>
              </div>
            </div>

            <div class="field-row">
              <div class="data-field col col100 w9-form">
                <div class="label">W-9 Form*</div>
                <div class="img-view full">
                  <div class="thumbnail">
                    <a :href="businessInfo.w9fileImg" target="_blank"
                      v-if="businessInfo.w9fileImg !== ''">
                      <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(businessInfo.w9fileImg)"></i>
                      <img :src="businessInfo.w9fileImg" v-else />
                    </a>
                    <i class="fa fa-image" v-if="businessInfo.w9fileImg === ''"></i>
                    <a @click="triggerUploadInput('w9fileImg')" v-if="editEnabled"
                      v-bind:class="['button cta xsmall block', imgUploadButton(businessInfo.w9fileImg).class, {'disabled':fileLoading.w9fileImg}]">
                      <span v-show="!fileLoading.w9fileImg">{{ imgUploadButton(businessInfo.w9fileImg).form }}</span>
                      <span v-show="fileLoading.w9fileImg">
                        <i class="fa fa-spinner fa-spin"></i>
                        {{ $t('provider.uploading') }}
                      </span>
                    </a>
                    <input type="file" ref="w9fileImg"  v-show="false"
                      @change="uploadImg" accept="image/*,application/pdf" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.documentation}">
      <div class="heading" @click="contentShow.documentation = !contentShow.documentation">
        <i class="fa fa-minus-circle" v-show="contentShow.documentation"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.documentation"></i>
        <span>{{ $t('provider.documentation.label') }}</span>
      </div>

      <div class="content documentation">
        <p class="documentation-notice" v-html="$t('provider.documenationNotice')"></p>
        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.insuranceImg" target="_blank"
                v-if="documentation.insuranceImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.insuranceImg)"></i>
                <img :src="documentation.insuranceImg" v-else/>
              </a>
              <i class="fa fa-image" v-if="documentation.insuranceImg === ''"></i>
              <a @click="triggerUploadInput('insuranceImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.insuranceImg).class, {'disabled':fileLoading.insuranceImg}]">
                <span v-show="!fileLoading.insuranceImg">{{ imgUploadButton(documentation.insuranceImg).label }}</span>
                <span v-show="fileLoading.insuranceImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="insuranceImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.insuranceCompany') }}</div>
                <input type="text" v-model="documentation.insuranceCompany" class="input" :disabled="!editEnabled" />
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.insurancePolicy') }}*</div>
                <input type="text" v-model="documentation.insurancePolicy" :disabled="!editEnabled"
                  @keyup="fieldValidate('documentation', 'insurancePolicy')"
                  :class="{'input':true, 'has-error':!!validation.documentation.insurancePolicy }"/>
                <span class="error-msg">{{ validation.documentation.insurancePolicy }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.insuranceExp') }}*</div>
                <datepicker :selected="fieldValidate('documentation', 'insuranceExp')" v-if="editEnabled"
                  :class="{'datepicker':true, 'has-error':!!validation.documentation.insuranceExp}"
                  v-model="documentation.insuranceExp" :format="calendarFormat"></datepicker>
                <input type="text" v-else disabled="disabled"
                  class="input" :value="documentation.insuranceExp" />
                <span class="error-msg">{{ validation.documentation.insuranceExp }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="two-col" v-show="accountType.type === 'tcp' || ((accountType.type === 'tnc' || accountType.type === 'psc') && enableTCPDocToTNC)">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.cityLicenseImg" target="_blank"
                v-if="documentation.cityLicenseImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.cityLicenseImg)"></i>
                <img :src="documentation.cityLicenseImg" v-else />
              </a>
              <i class="fa fa-image" v-if="documentation.insuranceImg === ''"></i>
              <a @click="triggerUploadInput('cityLicenseImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.cityLicenseImg).class, {'disabled':fileLoading.cityLicenseImg}]">
                <span v-show="!fileLoading.cityLicenseImg">{{ imgUploadButton(documentation.cityLicenseImg).label }}</span>
                <span v-show="fileLoading.cityLicenseImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="cityLicenseImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.cityLicense') }}*</div>
                <input type="text" v-model="documentation.cityLicense" :disabled="!editEnabled"
                  @keyup="fieldValidate('documentation', 'cityLicense')"
                  :class="{'input':true, 'has-error':!!validation.documentation.cityLicense }"/>
                <span class="error-msg">{{ validation.documentation.cityLicense }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.cityLicenseExp') }}*</div>
                <datepicker :selected="fieldValidate('documentation', 'cityLicenseExp')" v-if="editEnabled"
                  :class="{'datepicker':true, 'has-error':!!validation.documentation.cityLicenseExp}"
                  v-model="documentation.cityLicenseExp" :format="calendarFormat"></datepicker>
                <input type="text" v-else disabled="disabled" class="input" :value="documentation.cityLicenseExp" />
                <span class="error-msg">{{ validation.documentation.cityLicenseExp }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="two-col" v-show="accountType.type === 'tcp'">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.tcpPermitImg" target="_blank"
                v-if="documentation.tcpPermitImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.tcpPermitImg)"></i>
                <img :src="documentation.tcpPermitImg" v-else />
              </a>
              <i class="fa fa-image" v-if="documentation.tcpPermitImg === ''"></i>
              <a @click="triggerUploadInput('tcpPermitImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.tcpPermitImg).class, {'disabled':fileLoading.tcpPermitImg}]">
                <span v-show="!fileLoading.tcpPermitImg">{{ imgUploadButton(documentation.tcpPermitImg).label }}</span>
                <span v-show="fileLoading.tcpPermitImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="tcpPermitImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.tcpPermit') }}*</div>
                <input type="text" v-model="documentation.tcpPermit" :disabled="!editEnabled"
                  @keyup="fieldValidate('documentation', 'tcpPermit')"
                  :class="{'input':true, 'has-error':!!validation.documentation.tcpPermit }"/>
                <span class="error-msg">{{ validation.documentation.tcpPermit }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.tcpPermitExp') }}*</div>
                <datepicker :selected="fieldValidate('documentation', 'tcpPermitExp')" v-if="editEnabled"
                  :class="{'datepicker':true, 'has-error':!!validation.documentation.tcpPermitExp}"
                  v-model="documentation.tcpPermitExp" :format="calendarFormat"></datepicker>
                <input type="text" v-else disabled="disabled" class="input" :value="documentation.tcpPermitExp" />
                <span class="error-msg">{{ validation.documentation.tcpPermitExp }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="two-col" v-show="accountType.type === 'tcp'">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.airportPermitImg" target="_blank"
                v-if="documentation.airportPermitImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.airportPermitImg)"></i>
                <img :src="documentation.airportPermitImg" v-else />
              </a>
              <i class="fa fa-image" v-if="documentation.airportPermitImg === ''"></i>
              <a @click="triggerUploadInput('airportPermitImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.airportPermitImg).class, {'disabled':fileLoading.airportPermitImg}]">
                <span v-show="!fileLoading.airportPermitImg">{{ imgUploadButton(documentation.airportPermitImg).label }}</span>
                <span v-show="fileLoading.airportPermitImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="airportPermitImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.airportPermit') }}*</div>
                <input type="text" v-model="documentation.airportPermit" :disabled="!editEnabled"
                  @keyup="fieldValidate('documentation', 'airportPermit')"
                  :class="{'input':true, 'has-error':!!validation.documentation.airportPermit }"/>
                <span class="error-msg">{{ validation.documentation.airportPermit }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.airportPermitExp') }}*</div>
                <datepicker :selected="fieldValidate('documentation', 'airportPermitExp')" v-if="editEnabled"
                  :class="{'datepicker':true, 'has-error':!!validation.documentation.airportPermitExp}"
                  v-model="documentation.airportPermitExp" :format="calendarFormat"></datepicker>
                <input type="text" v-else disabled="disabled" class="input" :value="documentation.airportPermitExp" />
                <span class="error-msg">{{ validation.documentation.airportPermitExp }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.driversLicenseImg" target="_blank"
                v-if="documentation.driversLicenseImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.driversLicenseImg)"></i>
                <img :src="documentation.driversLicenseImg" v-else />
              </a>
              <i class="fa fa-image" v-if="documentation.driversLicenseImg === ''"></i>
              <a @click="triggerUploadInput('driversLicenseImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.driversLicenseImg).class, {'disabled':fileLoading.driversLicenseImg}]">
                <span v-show="!fileLoading.driversLicenseImg">{{ imgUploadButton(documentation.driversLicenseImg).label }}</span>
                <span v-show="fileLoading.driversLicenseImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="driversLicenseImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.driversLicense') }}*</div>
                <input type="text" v-model="documentation.driversLicense" :disabled="!editEnabled"
                  @keyup="fieldValidate('documentation', 'driversLicense')"
                  :class="{'input':true, 'has-error':!!validation.documentation.driversLicense }"/>
                <span class="error-msg">{{ validation.documentation.driversLicense }}</span>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.driversLicenseExp') }}*</div>
                <datepicker :selected="fieldValidate('documentation', 'driversLicenseExp')" v-if="editEnabled"
                  :class="{'datepicker':true, 'has-error':!!validation.documentation.driversLicenseExp}"
                  v-model="documentation.driversLicenseExp" :format="calendarFormat"></datepicker>
                <input type="text" v-else disabled="disabled" class="input" :value="documentation.driversLicenseExp" />
                <span class="error-msg">{{ validation.documentation.driversLicenseExp }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.vehicleInspectionImg" target="_blank"
                v-if="documentation.vehicleInspectionImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.vehicleInspectionImg)"></i>
                <img :src="documentation.vehicleInspectionImg" v-else />
              </a>
              <i class="fa fa-image" v-if="documentation.vehicleInspectionImg === ''"></i>
              <a @click="triggerUploadInput('vehicleInspectionImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.vehicleInspectionImg).class, {'disabled':fileLoading.vehicleInspectionImg}]">
                <span v-show="!fileLoading.vehicleInspectionImg">{{ imgUploadButton(documentation.vehicleInspectionImg).label }}</span>
                <span v-show="fileLoading.vehicleInspectionImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="vehicleInspectionImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.vehicleInspection') }}</div>
                <input type="text" class="input" v-model="documentation.vehicleInspection" :disabled="!editEnabled" />
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.vehicleInspectionExp') }}</div>
                <datepicker class="datepicker" v-model="documentation.vehicleInspectionExp"
                  :format="calendarFormat" v-if="editEnabled"></datepicker>
                <input type="text" v-else disabled="disabled" class="input" :value="documentation.vehicleInspectionExp" />
              </div>
            </div>
          </div>
        </div>

        <div class="two-col">
          <div class="img-view">
            <div class="thumbnail">
              <a :href="documentation.drivingRecordImg" target="_blank"
                v-if="documentation.drivingRecordImg !== ''">
                <i class="far fa-file-pdf fa-5x" v-if="isPdfFile(documentation.drivingRecordImg)"></i>
                <img :src="documentation.drivingRecordImg" v-else />
              </a>
              <i class="fa fa-image" v-if="documentation.drivingRecordImg === ''"></i>
              <a @click="triggerUploadInput('drivingRecordImg')" v-if="editEnabled"
                v-bind:class="['button cta xsmall block', imgUploadButton(documentation.drivingRecordImg).class, {'disabled':fileLoading.drivingRecordImg}]">
                <span v-show="!fileLoading.drivingRecordImg">{{ imgUploadButton(documentation.drivingRecordImg).label }}</span>
                <span v-show="fileLoading.drivingRecordImg">
                  <i class="fa fa-spinner fa-spin"></i>
                  {{ $t('provider.uploading') }}
                </span>
              </a>
              <input type="file" ref="drivingRecordImg"  v-show="false"
                @change="uploadImg" accept="image/*,application/pdf" />
            </div>
          </div>
          <div class="fields">
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.drivingRecord') }}</div>
              </div>
            </div>
            <div class="field-row">
              <div class="data-field col col100">
                <div class="label">{{ $t('provider.documentation.drivingRecordExp') }}</div>
                <datepicker class="datepicker" v-model="documentation.drivingRecordExp"
                  :format="calendarFormat" v-if="editEnabled"></datepicker>
                <input type="text" v-else disabled="disabled" class="input" :value="documentation.drivingRecordExp" />
              </div>
            </div>
          </div>
        </div>
        <div style="clear:both"></div>
      </div>
      <div style="clear:both"></div>
    </div>
    <div style="clear:both"></div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.eligibility}">
      <div class="heading" @click="contentShow.eligibility = !contentShow.eligibility">
        <i class="fa fa-minus-circle" v-show="contentShow.eligibility"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.eligibility"></i>
        <span>{{ $t('provider.eligibility.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col100">
            <div class="label">{{ $t('provider.eligibility.convicted') }}</div>
            <label class="radio">
              <input type="radio" class="input" name="convicted" :disabled="!editEnabled"
                v-model="eligibility.convicted" value="true" />
              Yes
            </label>
            <label class="radio">
              <input type="radio" class="input" name="convicted" :disabled="!editEnabled"
                v-model="eligibility.convicted" value="false" />
              No
            </label>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col100">
            <div class="label">{{ $t('provider.eligibility.conviction') }}</div>
            <label class="radio">
              <input type="radio" class="input" name="conviction" :disabled="!editEnabled"
                v-model="eligibility.conviction" value="true" />
              Yes
            </label>
            <label class="radio">
              <input type="radio" class="input" name="conviction" :disabled="!editEnabled"
                v-model="eligibility.conviction" value="false" />
              No
            </label>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col100">
            <div class="label">{{ $t('provider.eligibility.ownVehicle') }}</div>
            <label class="radio">
              <input type="radio" class="input" name="ownVehicle" :disabled="!editEnabled"
                v-model="eligibility.ownVehicle" value="true" />
              Yes
            </label>
            <label class="radio">
              <input type="radio" class="input" name="ownVehicle" :disabled="!editEnabled"
                v-model="eligibility.ownVehicle" value="false" />
              No
            </label>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col100">
            <div class="label">{{ $t('provider.eligibility.modifiedVehicle') }}</div>
            <label class="radio">
              <input type="radio" class="input" name="modifiedVehicle" :disabled="!editEnabled"
                v-model="eligibility.modifiedVehicle" value="true" />
                Yes
            </label>
            <label class="radio">
              <input type="radio" class="input" name="modifiedVehicle" :disabled="!editEnabled"
                v-model="eligibility.modifiedVehicle" value="false" />
              No
            </label>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col100">
            <div class="label">{{ $t('provider.eligibility.driversLicense') }}</div>
            <label class="radio">
              <input type="radio" class="input" name="driversLicense" :disabled="!editEnabled"
                  v-model="eligibility.driversLicense" value="true" />
              Yes
            </label>
            <label class="radio">
              <input type="radio" class="input" name="driversLicense" :disabled="!editEnabled"
                  v-model="eligibility.driversLicense" value="false" />
              No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.agreements}">
      <div class="heading" @click="contentShow.agreements = !contentShow.agreements">
        <i class="fa fa-minus-circle" v-show="contentShow.agreements"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.agreements"></i>
        <span>{{ $t('provider.agreements.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col100">
            <div class="checkbox">
              <input type="checkbox" id="declarePenalty"
                :checked="true" :disabled="true" />
              <label for="declarePenalty">{{ $t('provider.agreements.declarePenalty') }}</label>
            </div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col100">
            <div class="checkbox">
              <input type="checkbox" id="agree"
                 :checked="true" :disabled="true" />
              <label for="agree"
                v-html="$t('provider.agreements.agree', aggreementsLink)"></label>
            </div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col100">
            <div class="label">{{ $t('provider.agreements.signature') }}</div>
            <input type="text" v-model="signture" class="input" :disabled="true" />
            <div class="df-created">
              {{ ptrsDriverAgreeUTC ? `Accepted agreement on ${ptrsDriverAgreeUTC}` : createdDate(created) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import US from 'us'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import resetPassword from './ResetPassword'
import ApiServices from '@/modules/api/services'
import ApiProvider from '@/modules/api/provider/user-info'

let phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

export default {
  name: 'account-details',
  components: { datepicker, resetPassword },
  props: ['basicInfoImg', 'vehicleInfoImg', 'nextDrvrId'],
  data () {
    return {
      contentShow: {
        basicInfo: false,
        vehicleInfo: false,
        accountType: false,
        businessInfo: false,
        documentation: false,
        eligibility: false,
        agreements: false
      },
      countries: require('country-data').countries,
      services: {
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      },
      validation: {
        services: '',
        basicInfo: {
          firstName: '',
          lastName: '',
          deviceOS: '',
          deviceModel: '',
          language: '',
          email: '',
          mobile: '',
          phoneNumber: '',
          countryCode: '',
          birthday: '',
          img: ''
        },
        vehicleInfo: {
          manufacturer: '',
          model: '',
          year: '',
          type: '',
          licensePlate: '',
          capacity: '',
          boxCapacity: '',
          door: '',
          capacity: '',
          boxCapacity: '',
          identificationNumber: '',
          wheelchair: '',
          serviceDog: '',
          img: ''
        },
        accountType: {
          type: ''
        },
        businessInfo: {
          name: '',
          type: '',
          ssnImg: '',
          ssn: '',
          einImg: '',
          ein: '',
          address: '',
          address2: '',
          city: '',
          country: '',
          state: '',
          zip: '',
          w9fileImg: ''
        },
        documentation: {
          insuranceCompany: '',
          insurancePolicy: '',
          insuranceExp: '',
          insuranceImg: '',
          cityLicense: '',
          cityLicenseExp: '',
          cityLicenseImg: '',
          tcpPermit: '',
          tcpPermitExp: '',
          tcpPermitImg: '',
          airportPermit: '',
          airportPermitExp: '',
          airportPermitImg: '',
          driversLicense: '',
          driversLicenseExp: '',
          driversLicenseImg: '',
          vehicleInspection: '',
          vehicleInspectionExp: '',
          vehicleInspectionImg: '',
          drivingRecordExp: '',
          drivingRecordImg: '',
          vehicleRegistrationExp: '',
          vehicleRegistrationImg: '',
        },
        eligibility: {
          convicted: '',
          conviction: '',
          ownVehicle: '',
          modifiedVehicle: '',
          driversLicense: ''
        }
      },
      activeFileInput: '',
      fileLoading: {
        ssnImg: false,
        einImg: false,
        insuranceImg: false,
        cityLicenseImg: false,
        tcpPermitImg: false,
        airportPermitImg: false,
        driversLicenseImg: false,
        vehicleInspectionImg: false,
        drivingRecordImg: false,
        w9fileImg: false,
        vehicleRegistrationImg: false
      },
      isDisplayCountryCode: true,
      enableTCPDocToTNC: false,
      ssnOriginal: '',
      ssnImgOriginal: '',
      einOriginal: '',
      einImgOriginal: '',
      nextDriverId: '',
      driverIdError: '',
      driverIdSuccess: false,
      driverIdDelay: ''
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    quickRes () { return this.$store.state.provider.quickRes },
    backgroundSubmitted: {
      get: function () {
        return this.$store.state.provider.backgroundSubmitted
      },
      set: function (newValue) {
        this.$store.state.provider.backgroundSubmitted = newValue
      }
    },
    backgroundPassed: {
      get: function () {
        return this.$store.state.provider.backgroundPassed
      },
      set: function (newValue) {
        this.$store.state.provider.backgroundPassed = newValue
      }
    },
    isTestAcct: {
      get () { return this.$store.state.provider.isTestAcct },
      set (newValue) {
        this.$store.state.provider.isTestAcct = newValue
      }
    },
    maxDailyRsvpIsCustom: {
      get: function () {
        return this.$store.state.provider.maxDailyRsvpIsCustom
      },
      set: function (newValue) {
        this.$store.state.provider.maxDailyRsvpIsCustom = newValue
      }
    },
    maxDailyRsvp: {
      get: function () {
        return this.$store.state.provider.maxDailyRsvp
      },
      set: function (newValue) {
        this.$store.state.provider.maxDailyRsvp = newValue
      }
    },
    servicesData () { return this.$store.state.provider.services },
    basicInfo () { return this.$store.state.provider.basicInfo },
    vehicleInfo () { return this.$store.state.provider.vehicleInfo },
    accountType () { return this.$store.state.provider.accountType },
    businessInfo () { return this.$store.state.provider.businessInfo },
    documentation () { return this.$store.state.provider.documentation },
    eligibility () { return this.$store.state.provider.eligibility },
    signture () { return this.$store.state.provider.signature },
    states () {
      let states = []
      for (let key in US.states) {
        if (US.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: US.states[key].name
          })
        }
      }
      return states
    },
    aggreementsLink () {
      return {
        conductRules: '<a href="https://www.primetimerideshare.com/driver-conduct-rules" target="_blank">https://www.primetimerideshare.com/driver-conduct-rules</a>',
        terms: '<a href="https://www.primetimerideshare.com/terms" target="_blank">https://www.primetimerideshare.com/terms</a>',
        privacy: '<a href="https://www.primetimerideshare.com/privacy-policy" target="_blank">https://www.primetimerideshare.com/privacy-policy</a>',
      }
    },
    basicInfoLoading () { return this.$store.state.provider.upload.basicInfoLoading },
    vehicleInfoLoading () { return this.$store.state.provider.upload.vehicleInfoLoading },
    servicesLoading () { return this.$store.state.services.servicesLoading },
    useOldQuatation () { return CONFIG.useOldQuatation },
    editEnabled () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit') },
    callingCode () {
      if(this.isDisplayCountryCode) {
        this.$store.commit('countryCode/setCallingCode', this.basicInfo.countryCode)
        if(this.$store.state.countryCode.callingCode > 0) {
          this.isDisplayCountryCode = false
        }
      }
      return this.$store.state.countryCode.callingCode
    },
    isDoorToDoorEnabled () { return this.$store.state.provider.isDoorToDoorEnabled },
    driverId: {
      get () { return this.$store.state.provider.driverId },
      set (x) { this.$store.commit('provider/setDriverId', x) }
    },
    driverIdLoading: {
      get () { return this.$store.state.provider.driverIdLoading },
      set (x) { this.$store.commit('provider/setDriverIdLoading', x) }
    },
    driverNumEnabled () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderNum') },
    created () { return this.$store.state.provider.created },
    ptrsDriverAgreeUTC () { return this.$store.state.provider.ptrsDriverAgreeUTC }
  },
  methods: {
    selectCountry () {
      this.$store.commit('countryCode/setCountryModal', true)
    },
    updateAccountType (value) {
      this.$store.commit('provider/setAccountType', value)
      this.validateAll()
    },
    calendarFormat (date) {
      return moment(date).format('MM/DD/YYYY');
    },
    isPdfFile (file) { return file && file.indexOf('.pdf') > -1 },
    imgUploadButton (value) {
      let _class = value === '' || value === null ? 'error' : 'warning'
      let label = value === '' || value === null ? 'Upload Image' : 'Change Image'
      let form = value === '' || value === null ? 'Upload Form' : 'Change Form'

      return {
        class: _class,
        label: label,
        form: form
      }
    },
    save () {
      let self = this
      if (self.validateAll()) {
        // save Data
        self.$store.commit('provider/setFormLoading', true)
        ApiProvider.updateProvider(self, self.buildData(), function (res) {
          self.$store.commit('provider/setFormLoading', false)

          self.$store.commit('provider/setFormSavingDone', true)
          self.$store.commit('provider/setFormSaveMessage', self.$t('provider.formSuccessful'))
          if (res.error) {
            self.$store.commit('provider/setFormSaveMessage', res.error.message)
          }
        })
      }
    },
    validateAll () {
      let self = this
      let noError = true
      let errorMsg = {
        empty: self.$t('provider.emptyField'),
        email: self.$t('provider.invalidEmail'),
        emptyServices: self.$t('provider.emptyServices')
      }
      let isTcp = self.accountType.type === 'tcp'

      let serviceCount = 0
      for (let key in self.services) {
        if (!self.services[key]) {
          serviceCount++
        }
      }
      self.validation.services = ''
      if (self.useOldQuatation) {
        if (serviceCount === 5) {
          self.validation.services = errorMsg.emptyServices
          // noError = false
        }
      }

      let emailFormat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line
      for (let key in self.basicInfo) {
        self.validation.basicInfo[key] = ''
        if(key === 'email' && !emailFormat.test(self.basicInfo[key])) {
          self.validation.basicInfo[key] = errorMsg.email
          // noError = false
        }
        if (self.basicInfo[key] === '' || self.basicInfo[key] === null) {
          self.validation.basicInfo[key] = errorMsg.empty
          // noError = false
        }
      }

      let vehicleNoneRequiredField = ['wheelchair', 'serviceDog']
      if (!self.isDoorToDoorEnabled) {
        vehicleNoneRequiredField.push('boxCapacity')
      }
      
      for (let key in self.vehicleInfo) {
        self.validation.vehicleInfo[key] = ''
        if (vehicleNoneRequiredField.indexOf(key) > -1) { continue }

        if (self.vehicleInfo[key] === '' || self.vehicleInfo[key] === null) {
          self.validation.vehicleInfo[key] = errorMsg.empty
          // noError = false
        }
      }

      if (isTcp || ((self.accountType.type === 'tnc' || self.accountType.type === 'psc') && self.enableTCPDocToTNC)) {
        let businessNoneRequiredField = ['address2']
        for (let key in self.businessInfo) {
          self.validation.businessInfo[key] = ''
          if (key === 'state' && self.businessInfo.country !== 'United States' ||
            businessNoneRequiredField.indexOf(key) > -1
          ) {
            continue
          }

          // if ((self.businessInfo.type === 'Sole Proprietorship' && key === 'ein') ||
          if (self.businessInfo.type !== 'Sole Proprietorship' && key === 'ssn') {
            continue
          }

          if (self.businessInfo[key] === '' || self.businessInfo[key] === null) {
            self.validation.businessInfo[key] = errorMsg.empty
            // noError = false
          }
        }
      }

      let docuNoneRequiredField = [
        'insuranceCompany',
        'vehicleInspection', 'vehicleInspectionExp', 'vehicleInspectionImg',
        'drivingRecordExp', 'drivingRecordImg'
      ]
      let tncNoneRequiredField = [
        'cityLicense', 'cityLicenseExp', 'cityLicenseImg',
        'tcpPermit', 'tcpPermitExp', 'tcpPermitImg',
        'airportPermit', 'airportPermitExp', 'airportPermitImg'
      ]
      if ((self.accountType.type === 'tnc' || self.accountType.type === 'psc') && self.enableTCPDocToTNC) {
        tncNoneRequiredField.shift()
      }
      for (let key in self.documentation) {
        self.validation.documentation[key] = ''
        if (docuNoneRequiredField.indexOf(key) > -1 ||
          (!isTcp && tncNoneRequiredField.indexOf(key) > -1)
        ) {
          continue
        }

        if (self.documentation[key] === '' || self.documentation[key] === null) {
          self.validation.documentation[key] = errorMsg.empty
          // noError = false
        }
      }
      // self.$store.commit('provider/setFormHasError', !noError)
      return noError
    },
    fieldValidate (parent, child) {
      let self = this
      if (self[parent][child] !== '') {
        this.validation[parent][child] = ''
      } else {
        this.validation[parent][child] = self.$t('provider.emptyField')
      }

      self.saveButtonStatusCheck()
    },
    buildData () {
      let self = this
      let basicInfo = this.basicInfo
      let vehicleInfo = this.vehicleInfo
      let accountType = this.accountType
      let businessInfo = this.businessInfo
      let documentation = this.documentation
      let eligibility = this.eligibility

      let vehicleInspectionExp = ''
      let drivingRecordExp = ''
      let vehicleRegistrationExp = ''
      if (documentation.vehicleInspectionExp !== null && documentation.vehicleInspectionExp !== '') {
        vehicleInspectionExp = moment(documentation.vehicleInspectionExp, 'MM/DD/YYYY').format('YYYY-MM-DD')
      }
      if (documentation.drivingRecordExp !== null && documentation.drivingRecordExp !== '') {
        drivingRecordExp = moment(documentation.drivingRecordExp, 'MM/DD/YYYY').format('YYYY-MM-DD')
      }
      if (documentation.vehicleRegistrationExp !== null && documentation.vehicleRegistrationExp !== '') {
        vehicleRegistrationExp = moment(documentation.vehicleRegistrationExp, 'MM/DD/YYYY').format('YYYY-MM-DD')
      }

      let services = []
      for (let index in self.services) {
        if (self.services[index]) {
          services.push(index)
        }
      }

      let saveData = {
        id: this.$store.state.provider.id,
        firstName: basicInfo.firstName,
        lastName: basicInfo.lastName,
        email: basicInfo.email,
        model: basicInfo.deviceModel,
        OS: basicInfo.deviceOS,
        services: services,
        language: basicInfo.language.toLowerCase(),
        backgroundCheckPassed: this.backgroundPassed ? 1 : 0,
        backgroundCheckSubmitted: this.backgroundSubmitted ? 1 : 0,
        isTestAcct: this.isTestAcct ? 1 : 0,
        maxDailyRSVP: this.maxDailyRsvpIsCustom === '1' ? this.maxDailyRsvp : 0,
        dateOfBirth: moment(basicInfo.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        avatarUrl: basicInfo.img,
        // mobile: basicInfo.mobile,
        phoneNumber: basicInfo.phoneNumber,
        countryCode: this.$store.state.countryCode.callingCode, // basicInfo.countryCode
        businessName: businessInfo.name,
        businessType: businessInfo.type,
        // businessSSN: businessInfo.ssn,
        // businessSSNUrl: businessInfo.ssnImg,
        // businessEIN: businessInfo.ein,
        // businessEINUrl: businessInfo.einImg,
        address: businessInfo.address1,
        address2: businessInfo.address2,
        city: businessInfo.city,
        country: businessInfo.country,
        state: businessInfo.state,
        zip: businessInfo.zip,
        w9fileUrl: businessInfo.w9fileImg,
        vehicle: {
          manufactured:  moment(vehicleInfo.year, 'YYYY').format('YYYY'),
          seatCapacity: vehicleInfo.capacity,
          boxCapacity: vehicleInfo.boxCapacity,
          numberOfDoor: vehicleInfo.door,
          boxCapacity: vehicleInfo.boxCapacity,
          manufacturer: vehicleInfo.manufacturer,
          model: vehicleInfo.model,
          idNumber: vehicleInfo.identificationNumber,
          licensePlate: vehicleInfo.licensePlate,
          photoUrl: vehicleInfo.img,
          wheelChairLift: vehicleInfo.wheelchair,
          serviceDock: vehicleInfo.serviceDog,
          type: vehicleInfo.type
        },
        type: accountType.type,
        documents: {
          insurance: {
            company: documentation.insuranceCompany,
            policyNumber: documentation.insurancePolicy,
            policyExpire: moment(documentation.insuranceExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            policyFilename: documentation.insuranceImg
          },
          driverLicense: {
            number: documentation.driversLicense,
            expire: moment(documentation.driversLicenseExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.driversLicenseImg
          },
          cityLicense: {
            number: documentation.cityLicense,
            expire: moment(documentation.cityLicenseExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.cityLicenseImg
          },
          tcpPermit: {
            number: documentation.tcpPermit,
            expire: moment(documentation.tcpPermitExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.tcpPermitImg
          },
          airportPermit: {
            number: documentation.airportPermit,
            expire: moment(documentation.airportPermitExp, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            filename: documentation.airportPermitImg
          },
          safetyInspection: {
            by: documentation.vehicleInspection,
            expire: vehicleInspectionExp,
            filename: documentation.vehicleInspectionImg
          },
          drivingRecord: {
            expire: drivingRecordExp,
            filename: documentation.drivingRecordImg
          },
          vehicleRegistration: {
            expire: vehicleRegistrationExp,
            filename: documentation.vehicleRegistrationImg
          }
        },
        eligibility: {
          CrimeProblems: eligibility.convicted,
          DrivingProblems: eligibility.conviction,
          OwnVehicle: eligibility.ownVehicle,
          ModifiedVehicle: eligibility.modifiedVehicle,
          Tcp: eligibility.driversLicense
        }
      }

      if (self.ssnOriginal !== businessInfo.ssn) {
        saveData.businessSSN = businessInfo.ssn
      }
      if (self.ssnImgOriginal !== businessInfo.ssnImg) {
        saveData.businessSSNUrl = businessInfo.ssnImg
      }
      if (self.einOriginal !== businessInfo.ein) {
        saveData.businessEIN = businessInfo.ein
      }
      if (self.einImgOriginal !== businessInfo.einImg) {
        saveData.businessEINUrl = businessInfo.einImg
      }

      return saveData
    },
    saveButtonStatusCheck () {
      let self = this
      // let isTcp = self.accountType.type === 'tcp'
      let overAllError = false

      // if (self.validation.services !== '') {
      //   overAllError = true
      // }

      // for (let key in self.validation.basicInfo) {
      //   if (self.validation.basicInfo[key] !== '') {
      //     overAllError = true
      //   }
      // }
      // for (let key in self.validation.vehicleInfo) {
      //   if (key === 'boxCapacity' && !self.isDoorToDoorEnabled) { continue }
      //   if (self.validation.vehicleInfo[key] !== '') {
      //     overAllError = true
      //   }
      // }
      // if (isTcp) {
      //   for (let key in self.validation.businessInfo) {
      //     if (self.validation.businessInfo[key] !== '') {
      //       overAllError = true
      //     }
      //   }
      // }
      // let docuNoneRequiredField = [
      //   'insuranceCompany',
      //   'vehicleInspection', 'vehicleInspectionExp', 'vehicleInspectionImg',
      //   'drivingRecordExp', 'drivingRecordImg'
      // ]
      // let tncNoneRequiredField = [
      //   'cityLicense', 'cityLicenseExp', 'cityLicenseImg',
      //   'tcpPermit', 'tcpPermitExp', 'tcpPermitImg',
      //   'airportPermit', 'airportPermitExp', 'airportPermitImg'
      // ]
      // if ((self.accountType.type === 'tnc' || self.accountType.type === 'psc') && self.enableTCPDocToTNC) {
      //   tncNoneRequiredField.shift()
      // }
      // for (let key in self.validation.documentation) {
      //   if (docuNoneRequiredField.indexOf(key) > -1 ||
      //     (!isTcp && tncNoneRequiredField.indexOf(key) > -1)
      //   ) {
      //     continue
      //   }

      //   if (self.validation.documentation[key] !== '') {
      //     overAllError = true
      //   }
      // }

      for (let file in self.fileLoading) {
        if (self.fileLoading[file]) {
          overAllError = true
        }
      }

      self.$store.commit('provider/setFormHasError', overAllError)
    },
    showResetPassword () {
      if (this.$refs.resetPassword.showResetPassword()) {
        this.$refs.resetPassword.showResetPassword()
      }
    },
    triggerCropUpload (ref) {
      this.$store.commit('provider/showCropper', {
        show: true,
        ref: ref
      })
    },
    triggerUploadInput (ref) {
      this.activeFileInput = ref
      this.$refs[ref].click()
    },
    uploadImg (e) {
      let self = this
      let file = e.target.files[0]

      if (!file) { return }

      let activeFileInput = self.activeFileInput
      let fd = new FormData()
      fd.append('pic', file)

      self.fileLoading[activeFileInput] = true
      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        console.log('success', res)
        self.fileLoading[activeFileInput] = false
        if (!res.body.success) {
          self.$store.commit('provider/showUploadError', true)
          return
        }
        if (['ssnImg', 'einImg', 'w9fileImg'].indexOf(activeFileInput) > -1) {
          this.validation.businessInfo[activeFileInput] = ''
          self.businessInfo[activeFileInput] = res.body.data.url
        } else {
          this.validation.documentation[activeFileInput] = ''
          self.documentation[activeFileInput] = res.body.data.url
        }
      }, function (res) {
        console.log('error', res)
        self.fileLoading[activeFileInput] = false
        self.$store.commit('provider/showUploadError', true)
      })
    },
    serviceSelect () {
      let self = this
      let serviceCount = 0
      for (let key in self.services) {
        if (!self.services[key]) {
          serviceCount++
        }
      }

      self.validation.services = self.$t('provider.emptyServices')
      if (serviceCount !== 5) {
        self.validation.services = ''
      }
    },
    serviceLabel (code) { return ApiServices.getServiceName(code) },
    isNumber (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
        return
      }
      return true;
    },
    focusChangeCheck (target) {
      if (target === 'ssn' && this.ssnOriginal === this.businessInfo.ssn) {
        this.businessInfo.ssn = ''
      }
      if (target === 'ein' && this.einOriginal === this.businessInfo.ein) {
        this.businessInfo.ein = ''
      }
    },
    changeCheck (target) {
      if (target === 'ssn' && this.businessInfo.ssn === '') {
        this.businessInfo.ssn = this.ssnOriginal
      }
      if (target === 'ein' && this.businessInfo.ein === '') {
        this.businessInfo.ein = this.einOriginal
      }
    },
    confirmQuickRes () {
      if (!this.editEnabled) { return }
      this.$store.commit('provider/setQuickResData', {modal: true})
    },
    saveDriverId () {
      let self = this
      if (self.driverIdLoading) { return }
      if (self.driverIdDelay) {
        clearTimeout(self.driverIdDelay)
      }
      self.driverIdError = ''
      if (!self.driverId) {
        self.driverIdError = 'Please input driver id.'
        return
      }
      if (parseInt(self.driverId) < 310) {
        self.driverIdError = 'Using below 310 is not allowed.'
        return
      }
      self.driverIdLoading = true
      self.$sdk.post('/provider/' + self.provId, {
        token: self.$store.state.session.sessionToken,
        driverNum: self.nextDriverId
      }, res => {
        self.driverIdLoading = false
        if (res.error) {
          self.driverIdError = res.error.code === 'ER_DUP_ENTRY' ? 'Driver ID already exist.' : res.error.message
          return
        }

        self.nextDriverId = ''
        self.driverIdSuccess = true
        self.driverIdDelay = setTimeout(function () {
          self.driverIdSuccess = false
        }, 2000)
      })
    },
    createdDate (x) {
      if (!x) return x
      if (this.isBefore2026(x)) return '01/01/2026'
      return x
    },
    isBefore2026 (x) {
      let year = moment(x, 'MM/DD/YYYY').format('YYYY')
      year = parseInt(year)
      return year < 2026
    }
  },
  watch: {
    provId: function () {
      if (this.driverIdDelay) {
        clearTimeout(this.driverIdDelay)
      }
    },
    servicesData: function (value) {
      this.services = {
        shared: value.includes('shared'),
        opoli: value.includes('opoli'),
        black: value.includes('black'),
        suv: value.includes('suv'),
        shuttle: value.includes('shuttle')
      }
    },
    basicInfo: function (value) {
      this.contentShow = {
        basicInfo: true,
        vehicleInfo: true,
        accountType: true,
        businessInfo: true,
        documentation: true,
        eligibility: true,
        agreements: true
      }
      this.validateAll()
    },
    basicInfoImg: function (value) {
      if (value !== '') {
        this.basicInfo.img = value
        this.validation.basicInfo.img = ''
      }
    },
    vehicleInfoImg: function (value) {
      if (value !== '') {
        this.vehicleInfo.img = value
        this.validation.vehicleInfo.img = ''
      }
    },
    businessInfo: function () {
      this.ssnOriginal = this.businessInfo.ssn
      this.ssnImgOriginal = this.businessInfo.ssnImg
      this.einOriginal = this.businessInfo.ein
      this.einImgOriginal = this.businessInfo.einImg
    },
    isDoorToDoorEnabled: function () {
      this.saveButtonStatusCheck()
    },
    nextDrvrId (x) {
      this.nextDriverId = x
    }
  },
  mounted () {
    let self = this
    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true)
      ApiServices.getAllService(self, r => {
        self.$store.commit('services/setServiceLoading', false)
      })
    }

    this.nextDriverId = this.nextDrvrId

    self.enableTCPDocToTNC = self.$settings.get('EnableTCPDocToTNC') === 1
    setTimeout(() => {
      self.enableTCPDocToTNC = self.$settings.get('EnableTCPDocToTNC') === 1
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
$cta-link: #0D79F2;

.top-part{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px
}
.quick-res{
  line-height: 1;
  font-size: 14px;
  color: #555;
  font-weight: 600;
  margin-bottom: 3px;
}
.switch{
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 10px;
  .slider{
    position: relative;
    display: inline-block;
    width: 50px;
    height: 25px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;
    &.disabled{ opacity: .4; }
    &:before{
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 29px; }
    }
  }
  .label{
    display: inline-block;
    vertical-align: 7px;
    margin-left: 5px;
    font-size: 14px;
    color: #777;
    text-transform: uppercase;
  }
}
.driver-id{
  display: inline-table;
  vertical-align: top;
  position: relative;

  label{
    border:1px solid #ccc;
    border-right: none;
    background: #fafafa;
    padding: 0 5px;
    vertical-align: top;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    font-weight: 600;
    color: #555;
    display: inline-block;

    &.value{ display:none; }
  }
  input{
    display: inline-block;
    width: 60px;
    margin: 0;
    height: 30px;
    padding: 5px;
    font-size: 13px;
    color: #555;
    vertical-align: top;
    border-radius: 0;
    position: relative;
    cursor: default;
    text-align: center;
    z-index: 3;

    &.has-error{
      border: 1px solid #f20d0d;
    }
    &.filled{
      font-weight: 600;
      border: none;
      border-left: 1px solid #ccc;
    }
    &.no-access{
      background: #f3f3f3;
    }
  }
  button{
    border-radius: 0;
    font-size: 14px;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    vertical-align: top;
    padding: 0 10px;

    &.disabled{
      opacity: .5;
    }
  }
  .next-id{
    font-size: 14px;
    color: #777;
    font-weight: 500;
    margin-left: 5px;
  }
  .error-msg, .saved{
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    font-weight: 500;
    color: #f20d0d;
    white-space: nowrap;
  }
  .saved{
    top: 27px;
    color: #12c748!important;
    font-weight: 600;
    z-index: 1;
    padding-left: 6px;
  }
  &.filled{
    label{
      border: none;
      background: none;

      &.value{
        display: inline-block;
        font-weight: 600;
      }
    }
    input{
      display: none;
      font-weight: 600;
      border: none;
      background: none;
      width: auto!important;
    }
  }
}

.other-data{
  background: #fafafa;
  padding: 15px;
  border:1px solid #eaeaea;
  margin-bottom: 20px;

  .services{
    border-bottom: 1px solid #dadada;
    margin-bottom: 10px;
  }
}

.collapsible{
  margin-bottom: 5px;

  .heading{
    color: $cta-link;
    margin-bottom: 2px;
    cursor: pointer;
    text-transform: uppercase;

    i{ margin-right: 5px; }
    span { font-weight: 600; }
  }
  .content{
    margin-left: 6px;
    padding: 5px 0 5px 15px;
    border-left: 2px solid #ddd;
    max-height: 700px; /* define precise max-height for more smoother transition */
    height: auto;
    transition:all 0.35s ease-out;

    &.documentation{ max-height: 1900px; }
    .two-col{
      display: flex;
      margin-bottom: 20px;
      border-bottom: 1px dotted #cfcfcf;
      padding-bottom: 20px;

      &:last-child{ border-bottom: none; }
      .img-view{
        width: 30%;
        padding: 0 15px;
        display: inline-block;
        text-align: center;
        position: relative;

        &.full{
          width: 100%;
        }
        .thumbnail{
          width: 100%;
          padding: 15px 0;

          img {
            margin-bottom: 10px;
            max-height: 150px;
          }
          .fa-image{
            font-size: 80px;
            color: #c1cede;
            position: relative;
            z-index: 1;
          }
          .fa-spinner{
            margin-right: 5px;
          }
        }
      }
      .fields{
        width: 70%;
        display: inline-block;
      }
    }
    .field-row{ margin-bottom: 15px; }
    .field-row:last-child{ margin-bottom: 0; }
  }
  &.collapse .content{
    max-height: 0;
    overflow: hidden;
    padding: 0 15px;
  }
}

.ssn-ein-label{
  color: #888;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  line-height: 130%;
  margin-bottom: 10px;
}
.w9-form {
  .img-view{
    width: 100%;
    padding: 0!important;
    display: inline-block;
    text-align: left!important;
    position: relative;

    .thumbnail{
      width: 100%;
      padding: 15px 0;

      img {
        margin-bottom: 10px;
        max-height: 150px;
      }
      .fa-image{
        font-size: 80px;
        color: #c1cede;
        position: relative;
        z-index: 1;
      }
      .fa-spinner{
        margin-right: 5px;
      }

      .button {
        width: 30%;
        display: block;
      }
    }
  }
  .fields{
    width: 70%;
    display: inline-block;
  }
}

.field-row{
  box-sizing: border-box;
  display: flex;

  .col{ display: inline-block; }
  .col20{ width: 20%; }
  .col25{ width: 25%; }
  .col33{ width: 33%; }
  .col34{ width: 34%; }
  .col40{ width: 40%; }
  .col50{ width: 50%; }
  .col60{ width: 60%; }
  .col80{ width: 80%; }
  .col100{ width: 100%; }
}

.data-field{
  padding-right: 10px;
  position: relative;

  &.no-label{ padding-top: 17px; }
  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.bigger{ font-size: 14px; }
  }
  .input{
    margin: 5px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #fbfbfb; }
  }
  select{
    margin-top: 5px;
    border: 1px solid #ddd;
    padding: 10px;
    color: #333;
    height: 45px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('/assets/img/down.png') no-repeat right 12px;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #fbfbfb; }
  }
  .checkbox{
    line-height: 100%;
    margin-bottom: 3px;

    &.inline{
      display:inline-block;
      margin: 0 25px 10px 0;
    }
    &:last-child{ margin-bottom: 0; }
    input{
      display: inline-block;
      width: auto;
      vertical-align: -2px;
      margin: 0 5px 0 0;
    }
    label{
      font-size: 14px;
      color: #555;
      line-height: 150%;
    }
  }
  .radio{
    display: block;
    color: #333;
    font-size: 14px;
    margin-top: 5px;

    &:first-child{ margin-top: 5px; }
    input{
      display: inline-block;
      width: auto;
      margin: 0 0 0 5px;
    }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
  .df-created{
    text-align: center;
    letter-spacing: .6px;
    font-size: 14px;
    color: #777;
    line-height: 1;
    margin-top: 10px;
  }
}

.datepicker{
  position: relative;
  margin-top:3px;
  /*top: -10px;*/
}

.fa-file-pdf{
  margin-bottom: 10px;
  color: #f44f4f;
}

.reset-password-wrap{
  position: relative;
  overflow: hidden;
}
.mark-test-account{
  color: #333;
  font-size: 14px;
  letter-spacing: .3px;
  border: 1px solid #c5b359;
  background: #fffbe8;
  padding: 10px 8px;
  line-height: 1;

  label{
    cursor: pointer;
  }
  input{
    width: auto;
    display: inline-block;
    margin: 0 3px 0 0;
    vertical-align: -1px;
  }
}

.documentation-notice{
  margin: 0 0 25px;
  font-size: 12px;
  color: #777;
  i { font-weight: 600; }
}

.input-group {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  position: relative;
  margin-bottom: 0;

 .input-group-label {
  padding: 0 10px;
  border: 1px solid #cacaca;
  background: #f4f8f9;
  color: #0a0a0a;
  text-align: center;
  white-space: nowrap;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
 }

 .mobile-input {
  padding-left: 25px;
  border-radius: 1px;
  border-left: 0;
 }

  &.small {
    .mobile-input {
      padding-left: 35px;
    }
  }
  &.medium {
    .mobile-input {
      padding-left: 45px;
    }
  }
  &.large {
    .mobile-input {
      padding-left: 55px;
    }
  }
  &.xl {
    .mobile-input {
      padding-left: 65px;
    }
  }

}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.country-select {
  margin-top: 5px;
  cursor: pointer;
  color: #333;
  transition: 0.3s;
}

.country-select:hover {
  background-color: #e6e6e6;
}

.country-code {
  margin-right: 3px;
  font-weight: 100;
}

@media only screen and (max-width: 430px) {
  .top-part{
    display: block;
    .driver-id{ width: 100%; }
  }
  .data-field.no-label { padding-top: 0; }
  .collapsible .content .field-row { margin: 0; }
  .data-field .label { margin-top: 10px; }
  .data-field .checkbox { margin-top: 5px;}
  .data-field.pwd { margin-top: 10px;}

  .field-row {
    flex-direction: column;

    .col50, .col33, .col34 {
      width: 100%;
    }

    .col40 {
      width: 100%;
    }

    .password-div {
      margin-top: 20px;
      text-align: center;
    }
  }

  .collapsible {
    .content {
      max-height: none;

      .two-col {
        display: flex;
        flex-direction: column;

        .img-view {
          width: 100%;
        }

        .fields {
          width: 100%;
        }
      }

      &.documentation {
        max-height: none;
      }
    }
  }

  .w9-form .img-view .thumbnail {
    text-align: center;
    .button {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/AccountDetails.vue